module.exports = __webpack_public_path__ + "img/id-front.2839a60c.svg";